import React from "react";

const IconFolderSearch = () => (
  <svg
    width="32"
    height="23"
    viewBox="0 0 32 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.4581 0.0011516C21.3299 0.0011516 24.6208 4.74238 26.2488 4.86636H0V2.4923C0.00109866 1.82998 0.192174 1.19537 0.531216 0.728009C0.870258 0.260645 1.32951 -0.00121502 1.808 4.23874e-06V0.0011516H19.4581Z"
      fill="#003F85"
    />
    <path
      d="M0 4.86627H30.8203C31.4718 4.86627 32 5.39445 32 6.046V20.94C32 21.5915 31.4718 22.1197 30.8203 22.1197H1.17972C0.528181 22.1197 0 21.5915 0 20.94V4.86627Z"
      fill="#003F85"
    />
  </svg>
);

export default IconFolderSearch;
